import {eqStringUnion, NonEmptyString, StringUnion} from 'Core/models/EmptyString';
import {ToMatchOptions} from 'Shared/utilities/MapDiscriminatedUnion';
import {Eq, getStructEq} from 'fp-ts/lib/Eq';

export class UnchangedNameInformation {
  public readonly key = 'UnchangedNameInformation';

  constructor(public readonly firstName: StringUnion, public readonly lastName: StringUnion) {}
}

export class InvalidNameInformation {
  public readonly key = 'InvalidNameInformation';

  constructor(public readonly firstName: StringUnion, public readonly lastName: StringUnion) {}
}

export class SavingNameInformation {
  public readonly key = 'SavingNameInformation';

  constructor(public readonly firstName: StringUnion, public readonly lastName: StringUnion) {}
}

export class ValidNameInformation {
  public static create(firstName: StringUnion, lastName: StringUnion) {
    return firstName instanceof NonEmptyString && lastName instanceof NonEmptyString
      ? new ValidNameInformation(firstName, lastName)
      : new InvalidNameInformation(firstName, lastName);
  }

  public readonly key = 'ValidNameInformation';
  constructor(public readonly firstName: NonEmptyString, public readonly lastName: NonEmptyString) {}
}

export type NameInformation =
  | SavingNameInformation
  | ValidNameInformation
  | InvalidNameInformation
  | UnchangedNameInformation;

export type NameInformationOptions<TReturn> = ToMatchOptions<NameInformation, 'key', TReturn>;

export const matchNameInformation = <TReturn>(
  nameInformation: NameInformation,
  options: NameInformationOptions<TReturn>
): TReturn => {
  switch (nameInformation.key) {
    case 'SavingNameInformation':
      return options.SavingNameInformation(nameInformation);
    case 'InvalidNameInformation':
      return options.InvalidNameInformation(nameInformation);
    case 'UnchangedNameInformation':
      return options.UnchangedNameInformation(nameInformation);
    case 'ValidNameInformation':
      return options.ValidNameInformation(nameInformation);
  }
};

export const eqNameInformation: Eq<NameInformation> = getStructEq({
  firstName: eqStringUnion,
  lastName: eqStringUnion,
});
